<!-- Breadcrumbs -->
<ol class="breadcrumb mt_1">
  <li
    class="breadcrumb_item"
    [class.active]="isLast"
    *ngFor="let breadcrumb of breadcrumbs$ | async; last as isLast; let index = index">
    <a
      [ngClass]="{
        'disable-link':
          disabledRoutesList.includes(breadcrumb.label) || (disable && index === 1) || (routeLink && index === 2)
      }"
      [routerLink]="customIndex === index ? route : breadcrumb.url"  [queryParams]="breadcrumbBackFilter"
      >{{ customIndex === index ? redirectedFrom : (breadcrumb.label | translate)
      }}<a *ngIf="isLast">{{ customTitle | translate }}</a></a
    >
  </li>
</ol>
